module.exports = __webpack_public_path__ + "0cff8741eaf1ecca0792aea296b3b0d6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-14.png
// module id = 2093
// module chunks = 0